import React, { Component } from 'react';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Page } from 'components/page-container';
import { PageHeader } from 'components/page-header';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { DataTable } from 'damco-components';
import { IStore } from 'reducers/index';
import {
    IExportExtraDocumentConfiguration,
    IExportExtraDocumentConfigurations,
    IExtraDocumentConfigurationListModel,
    IImportExtraDocumentConfiguration,
    IImportExtraDocumentConfigurations,
    IToggleActiveExtraDocumentConfiguration,
} from 'reducers/extraDocument/models';
import {
    addExportExtraDocumentConfiguration,
    updateExportExtraDocumentConfiguration,
    fetchExportExtraDocumentConfigurationById,
    resetExportExtraDocumentConfiguration,
    searchExportExtraDocumentConfiguration,
    toggleActiveExtraDocumentConfiguration,
    fetchImportExtraDocumentConfigurationById,
    resetImportExtraDocumentConfiguration,
    addImportExtraDocumentConfiguration,
    updateImportExtraDocumentConfiguration,
    searchImportExtraDocumentConfiguration,
    processExtraDocumentCreationImport,
    processExtraDocumentCreationExport,
} from 'actions/extraDocument';
import { AddEditExtraDocConfigDialog } from 'modules/extraDocument/AddEditExtraDocConfigDialog';
import {
    ExtraDocExportConfigTableData,
    ExtraDocImportConfigTableData,
} from './extraDocConfigColumnData';
import { ConfirmModal } from 'components/confirm-modal';
import { INickname } from 'reducers/nickname';
import { InPageDialog } from 'damco-components';
import { applyFiltersAction, clearFilters, resetSort, setFilter, setSort } from 'actions/filters';
import { ISortModel, SORT_ORDER } from 'reducers/filters/models';
import { ExtraDocumentCreation } from 'modules/extraDocumentCreation/Index';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { isFeatureEnabled } from 'utilities/util';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { originDestDropdownNew, searchProductTypesExtra, transportationDropdown } from 'constants/customs';

interface IMapDispatchToProps {
    searchExportExtraDocument: (pageNumber?: number, pageSize?: number) => Promise<void>;
    searchImportExtraDocument: (pageNumber?: number, pageSize?: number) => Promise<void>;
    fetchExportExtraDocumentConfigurationById: (itemData: IExtraDocumentConfigurationListModel) => Promise<void>;
    addExportExtraDocumentConfiguration: (data: IExportExtraDocumentConfiguration) => Promise<void>;
    updateExportExtraDocumentConfiguration: (data: IExportExtraDocumentConfiguration) => Promise<void>;
    resetExportExtraDocumentConfiguration: () => Promise<void>;
    fetchImportExtraDocumentConfigurationById: (itemData: IExtraDocumentConfigurationListModel) => Promise<void>;
    addImportExtraDocumentConfiguration: (data: IImportExtraDocumentConfiguration) => Promise<void>;
    updateImportExtraDocumentConfiguration: (data: IImportExtraDocumentConfiguration) => Promise<void>;
    resetImportExtraDocumentConfiguration: () => Promise<void>;
    toggleActiveExtraDocumentConfiguration: (data: IToggleActiveExtraDocumentConfiguration) => Promise<void>;
    clearFilters: () => void;
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    applyFilters: () => void;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    processExtraDocumentCreationImport: (data: any) => Promise<void>;
    processExtraDocumentCreationExport: (data: any) => Promise<void>;
}

interface IMapStateToProps {
    isFetchDataLoading: boolean;
    isFetchDataError: boolean;
    pendingError: string | string[];
    exportExtraDocumentConfigs: IExportExtraDocumentConfigurations;
    importExtraDocumentConfigs: IImportExtraDocumentConfigurations;
    currentUserNickName: INickname;
    exportExtraDocumentConfig: IExportExtraDocumentConfiguration;
    importExtraDocumentConfig: IImportExtraDocumentConfiguration;
    addExportResponse: any;
    updateExportResponse: any;
    addImportResponse: any;
    updateImportResponse: any;
    toggleActiveResponse: any;
    processExtraDocumentCreationImportRes: any;
    processExtraDocumentCreationExportRes: any;
    featureToggles: IFeatureToggleModel[];
}

interface IProps
    extends RouteComponentProps,
    IMapStateToProps,
    IMapDispatchToProps { }

interface IExtraDocumentsState {
    confirmDialogVisible: boolean;
    extraDocumentCreationVisible: boolean;
    confirmDialogMessage: string;
    currentTabSelected: number;
    showExtraDocModal: boolean;
    showStatusDialog: boolean;
    statusDialogMessage: string;
    statusDialogIsError: boolean;
    isFiltersDisabled: boolean;
    importData: IImportExtraDocumentConfiguration[];
    exportData: IExportExtraDocumentConfiguration[];
    currentSorted: string;
    rowIds: any;
    documentNbr: any;
    shouldFetch: boolean,
}


export class _ExtraDocuments extends Component<IProps, IExtraDocumentsState> {
    public filters: any;
    public debouncedParseAndFilterData: any;
    public importTableReference: any;
    public exportTableReference: any;
    public state: IExtraDocumentsState = {
        confirmDialogVisible: false,
        extraDocumentCreationVisible: false,
        confirmDialogMessage: '',
        currentTabSelected: 1,
        showExtraDocModal: false,
        showStatusDialog: false,
        statusDialogMessage: '',
        statusDialogIsError: false,
        isFiltersDisabled: true,
        importData: [],
        exportData: [],
        currentSorted: '[]',
        rowIds: [],
        documentNbr: [],
        shouldFetch: false,
    };
    constructor(props: IProps) {
        super(props);
    }

    public componentDidMount() {
        this.props.resetSort();
        this.props.clearFilters();
        this.setCurrTab();
    }

    public componentWillUnmount() {
        this.props.resetSort();
        this.props.clearFilters();
        this.setState({ shouldFetch: false });

    }
    public componentDidUpdate(prevProps: IProps, prevState: IExtraDocumentsState) {
        if (this.props.exportExtraDocumentConfigs !== prevProps.exportExtraDocumentConfigs && this.props.exportExtraDocumentConfigs) {
            const data: IExportExtraDocumentConfigurations = JSON.parse(
                JSON.stringify(this.props.exportExtraDocumentConfigs)
            );
            data.result = data.result.map((el, index: number) => {
                el.isDeleted = el.isDeleted ? 'In-Active' : 'Active';
                el.type = el.type === 'ESSO' ? 'Export' : el.type === 'ISSO' ? 'Import' : el.type;
                return el;
            });
            this.setState({
                exportData: data.result
            });
        }
        if (this.props.importExtraDocumentConfigs !== prevProps.importExtraDocumentConfigs && this.props.importExtraDocumentConfigs) {
            const data: IImportExtraDocumentConfigurations = JSON.parse(
                JSON.stringify(this.props.importExtraDocumentConfigs)
            );
            data.result = data.result.map((el) => {
                el.isDeleted = el.isDeleted ? 'In-Active' : 'Active';
                el.type = el.type === 'ESSO' ? 'Export' : el.type === 'ISSO' ? 'Import' : el.type;
                return el;
            });
            this.setState({
                importData: data.result
            });
        }

        if (this.props.addExportResponse !== prevProps.addExportResponse) {
            if (this.props.addExportResponse === true) {
                this.setState({
                    showExtraDocModal: false,
                    showStatusDialog: true,
                    statusDialogMessage: 'Extra document configuration created successfully.',
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
        if (this.props.updateExportResponse !== prevProps.updateExportResponse) {
            if (this.props.updateExportResponse === true) {
                this.setState({
                    showExtraDocModal: false,
                    showStatusDialog: true,
                    statusDialogMessage: 'Extra document configuration updated successfully.',
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
        if (this.props.addImportResponse !== prevProps.addImportResponse) {
            if (this.props.addImportResponse === true) {
                this.setState({
                    showExtraDocModal: false,
                    showStatusDialog: true,
                    statusDialogMessage: 'Extra document configuration created successfully.',
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
        if (this.props.updateImportResponse !== prevProps.updateImportResponse) {
            if (this.props.updateImportResponse === true) {
                this.setState({
                    showExtraDocModal: false,
                    showStatusDialog: true,
                    statusDialogMessage: 'Extra document configuration updated successfully.',
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
        if (this.props.toggleActiveResponse !== prevProps.toggleActiveResponse) {
            if (this.props.toggleActiveResponse === true) {
                this.setState({
                    showExtraDocModal: false,
                    showStatusDialog: true,
                    statusDialogMessage:
                        'Extra document configuration status toggled successfully.',
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
        if (this.props.processExtraDocumentCreationExportRes !== prevProps.processExtraDocumentCreationExportRes) {
            if (this.props.processExtraDocumentCreationExportRes === true) {
                this.setState({
                    extraDocumentCreationVisible: false,
                    showStatusDialog: true,
                    statusDialogMessage:
                        `Successfully generated extra document for Document numbers - ${this.state.documentNbr}`,
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
        if (this.props.processExtraDocumentCreationImportRes !== prevProps.processExtraDocumentCreationImportRes) {
            if (this.props.processExtraDocumentCreationImportRes === true) {
                this.setState({
                    extraDocumentCreationVisible: false,
                    showStatusDialog: true,
                    statusDialogMessage:
                        `Successfully generated extra document for ETS - ${this.state.documentNbr}`,
                    statusDialogIsError: false,
                });
                this.refreshData();
            }
        }
    }

    public setCurrTab = (selectedId?: number) => {
        let thisUrl = this.props.location.pathname;
        thisUrl = thisUrl.replace('/administration/extra-document', '');
        let id = selectedId ? selectedId : 1;
        if (!selectedId) {
            switch (thisUrl) {
                case '/export':
                    id = 1;
                    break;
                case '/import':
                    id = 2;
                    break;
            }
        }
        this.setState({
            currentTabSelected: id,
        });
    };

    public setSortForTable = (data: Array<{ desc: boolean, id: string; }>) => {
        if (data && data.length > 0) {
            if (data[0].id === 'incoTerm' || data[0].id === 'documentIssuer') {
                return;
            }
            const order = data[0].desc ? SORT_ORDER.DESCENDING : SORT_ORDER.ASCENDING;
            const sort = {
                column: this.capitalizeFirstLetter(data[0].id),
                order,
                desc: data[0].desc,
            };
            this.props.setSort(sort);
        }
    };

    public capitalizeFirstLetter = (input: string) => {
        return input.charAt(0).toUpperCase() + input.slice(1);
    };

    public refreshData = () => {
        if (this.state.currentTabSelected === 1) {
            this.props.searchExportExtraDocument(1, Number(localStorage.getItem('pageSize-ExtraDocumentExportTable') ?? 10));
            if (this.exportTableReference) {
                this.exportTableReference.resetPages();
                this.exportTableReference.setState({ selected: [] });
            }
        }
        else if (this.state.currentTabSelected === 2) {
            this.props.searchImportExtraDocument(1, Number(localStorage.getItem('pageSize-ExtraDocumentImportTable') ?? 10));
            if (this.importTableReference) {
                this.importTableReference.resetPages();
                this.importTableReference.setState({ selected: [] });
            }
        }
    };

    public processModalData = (data: any) => {
        if (data) {
            if (data.type === 'Export') {
                const exportData = data;
                exportData.productType = exportData.productTypeExport;
                delete exportData.productTypeExport;
                if (data.id) {
                    this.props.updateExportExtraDocumentConfiguration(exportData);
                } else {
                    this.props.addExportExtraDocumentConfiguration(exportData);
                }
            }
            else if (data.type === 'Import') {
                const importData = data;
                importData.productType = importData.productTypeImport;
                delete importData.productTypeImport;
                if (data.id) {
                    this.props.updateImportExtraDocumentConfiguration(importData);
                } else {
                    this.props.addImportExtraDocumentConfiguration(importData);
                }
            }
        } else {
            this.setState({ showExtraDocModal: false });
        }
    };

    public confirmToggle = () => {
        this.setState({ confirmDialogVisible: false });
        const currentSelectedItems = this.state.currentTabSelected === 1 ? this.exportTableReference.getSelectedItems() : this.importTableReference.getSelectedItems();
        const requestObj: IToggleActiveExtraDocumentConfiguration = {
            id: currentSelectedItems[0].id,
            isDeleted: currentSelectedItems[0].isDeleted !== 'In-Active',
            updatedBy: this.props.currentUserNickName.employeeId,
        };
        this.props.toggleActiveExtraDocumentConfiguration(requestObj);
    };


    public clear() {
        this.props.clearFilters();
        if (this.exportTableReference) {
            this.exportTableReference.resetPages();
            this.exportTableReference.setState({ selected: [] });
        }
        else if (this.importTableReference) {
            this.importTableReference.resetPages();
            this.importTableReference.setState({ selected: [] });
        }

        if (!this.state.shouldFetch) {
            this.refreshData();
        }
    }
    public apply() {
        if (!this.state.shouldFetch) {
            this.refreshData();
        }
    }

    public fetchExtraDocumentConfigData(tableState: any, instance: any, type: 'export' | 'import') {
        if (JSON.stringify(this.state.currentSorted) !== JSON.stringify(tableState.sorted)) {
            this.setState({ currentSorted: tableState.sorted });
        }
        else if ((tableState.page !== instance.state.page)) {
            return;
        }

        this.setSortForTable(tableState.sorted);
        if (type === 'export') {
            this.props.searchExportExtraDocument(tableState.page + 1, tableState.pageSize);
        }
        else if (type === 'import') {
            this.props.searchImportExtraDocument(tableState.page + 1, tableState.pageSize);
        }
    }

    public processExtraDocumentCreation = async () => {
        if (this.state.currentTabSelected === 1) {
            const selectedData = this.exportTableReference.getSelectedItems()[0];
            const query = {
                Prefix: selectedData.prefix,
                ExportJobIds: this.state.rowIds,
                SalesOffice: selectedData.salesOffice,
                SalesOrganization: selectedData.salesOrganization,
                Division: selectedData.division,
                Plant: selectedData.plant,
                CompanyCode: selectedData.companyCode,
                DocumentIssuerCountryCode: selectedData.documentIssuerCountryCode,
                DocumentIssuerBusinessEntityCode: selectedData.documentIssuerBusinessEntityCode,
                DocumentIssuerFunctionCode: selectedData.documentIssuerFunctionCode
            };
            this.props.processExtraDocumentCreationExport(query);
        }
        if (this.state.currentTabSelected === 2) {
            const selectedData = this.importTableReference.getSelectedItems()[0];
            const query = {
                Category: 1,
                ReferenceIds: this.state.rowIds,
                ConfigurationOutput: {
                    SalesOffice: selectedData.salesOffice,
                    SalesOrganization: selectedData.salesOrganization,
                    Division: selectedData.division,
                    Plant: selectedData.plant,
                    CompanyCode: selectedData.companyCode
                }
            };
            this.props.processExtraDocumentCreationImport(query);
        }

    };
    public getSelectedRows = async (rows: any) => {
        const ids = rows.map((item: any) => item.id);
        this.setState({ rowIds: ids.length > 0 ? ids : 0, documentNbr: rows.map((item: any) => item.documentNbr) });
    };

    public render() {
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        const parentContextualActionsList = [
            {
                isMoreBtn: false,
                label: 'Update',
                action: () => {
                    if (this.state.currentTabSelected === 1) {
                        const selectedUpdateData = this.exportTableReference.getSelectedItems()[0];
                        this.props.resetExportExtraDocumentConfiguration();
                        this.props.resetImportExtraDocumentConfiguration();
                        this.setState({ showExtraDocModal: true });
                        this.props.fetchExportExtraDocumentConfigurationById(selectedUpdateData);
                    }
                    else {
                        const selectedUpdateData = this.importTableReference.getSelectedItems()[0];
                        this.props.resetExportExtraDocumentConfiguration();
                        this.props.resetImportExtraDocumentConfiguration();
                        this.setState({ showExtraDocModal: true });
                        this.props.fetchImportExtraDocumentConfigurationById(selectedUpdateData);
                    }
                },
            },
            {
                isMoreBtn: false,
                label: 'Toggle Active',
                action: () => {
                    const currentSelectedItems =
                        this.state.currentTabSelected === 1
                            ? this.exportTableReference.getSelectedItems()
                            : this.importTableReference.getSelectedItems();
                    this.setState({
                        confirmDialogVisible: true,
                        confirmDialogMessage: `Are you sure you want to ${currentSelectedItems[0].isDeleted === 'Active'
                            ? 'deactivate'
                            : 'activate'
                            } configuration item ID-${currentSelectedItems[0].id}`,
                    });
                },
            },
            {
                isMoreBtn: false,
                label: this.state.currentTabSelected === 1 ? `Generate Extra Doc for Old ${isHblConsumptionEnabled ? 'FCR/HBL' : 'FCR'}` : 'Generate Extra Doc for Old ETS',
                action: () => {
                    this.setState({
                        extraDocumentCreationVisible: true,
                    });
                },
            }
        ];
        const actionsList = {
            primaryActionIsMoreBtn: false,
            primaryActionLabel: 'Create New',
            primaryAction: () => {
                this.props.resetExportExtraDocumentConfiguration();
                this.props.resetImportExtraDocumentConfiguration();
                this.setState({
                    showExtraDocModal: true,
                });
            },
            secondaryActions: [],
            parentContextualActions: parentContextualActionsList,
        };

        const isBKSFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BKS_EXTRA_DOC, this.props.featureToggles);
        const isDCSFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_DCS_EXTRA_DOC, this.props.featureToggles);
        const isFinopsAirEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_AIR, this.props.featureToggles);
        const isRailRoadEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ROAD_RAIL, this.props.featureToggles);
        const optionsWithDCS = [
            ...searchProductTypesExtra,
            { optionText: 'DCS', value: 8 },
        ];
        let filtersToAdd;
        const filtersToAddExport = [
            <FiltersInput
                key="shipper"
                name="shipper"
                id="shipper"
                label="Shipper"
            />,
            <FiltersInput
                key="consignee"
                name="consignee"
                id="consignee"
                label="Consignee"
            />,
            <FiltersInput
                key="portOfLoading"
                name="portOfLoading"
                id="portOfLoading"
                label="Port of Loading"
            />,
            <FiltersInput
                key="placeOfReceipt"
                name="placeOfReceipt"
                id="placeOfReceipt"
                label="Place of Receipt"
            />,
            <FiltersSelect
                key="originService"
                name="originService"
                id="originService"
                label="Origin Service"
                isRequired={false}
                options={originDestDropdownNew}
            />,
            <FiltersSelect
                key="destinationService"
                name="destinationService"
                id="destinationService"
                label="Destination Service"
                isRequired={false}
                options={originDestDropdownNew}
            />,
            <FiltersSelect
                key="transportationMode"
                name="transportationMode"
                id="transportationMode"
                label="Transportation Mode"
                isRequired={false}
                options={transportationDropdown}
            />
        ];
        const filtersToAddImport = [
            <FiltersInput
                key="consignee"
                name="consignee"
                id="consignee"
                label="Consignee"
            />,
            <FiltersInput
                key="portOfLoading"
                name="portOfLoading"
                id="portOfLoading"
                label="Port of Loading"
            />,
            <FiltersInput
                key="clientPlaceOfDelivery"
                name="clientPlaceOfDelivery"
                id="clientPlaceOfDelivery"
                label="Client Place Of Delivery"
            />,
            <FiltersInput
                key="placeOfReceipt"
                name="placeOfReceipt"
                id="placeOfReceipt"
                label="Place of Receipt"
            />,
            <FiltersInput
                key="carrierPlaceOfDelivery"
                name="carrierPlaceOfDelivery"
                id="carrierPlaceOfDelivery"
                label="Carrier Place Of Delivery"
            />,
            <FiltersInput
                key="portOfDischarge"
                name="portOfDischarge"
                id="portOfDischarge"
                label="Port Of Discharge"
            />,
            <FiltersSelect
                key="transportationMode"
                name="transportationMode"
                id="transportationMode"
                label="Transportation Mode"
                isRequired={false}
                options={transportationDropdown}
            />,
            <FiltersSelect
                key="originService"
                name="originService"
                id="originService"
                label="Origin Service"
                isRequired={false}
                options={originDestDropdownNew}
            />,
            <FiltersSelect
                key="destinationService"
                name="destinationService"
                id="destinationService"
                label="Destination Service"
                isRequired={false}
                options={originDestDropdownNew}
            />,
            <FiltersInput
                key="companyCode"
                name="companyCode"
                id="companyCode"
                label="Company Code"
            />,
            <FiltersInput
                key="salesOrg"
                name="salesOrg"
                id="salesOrg"
                label="Sales Org"
            />,
            <FiltersInput
                key="division"
                name="division"
                id="division"
                label="Division"
            />,
            <FiltersInput
                key="salesOffice"
                name="salesOffice"
                id="salesOffice"
                label="Sales Office"
            />,
            <FiltersInput
                key="plant"
                name="plant"
                id="plant"
                label="Plant"
            />
        ];
        if (isBKSFeatureEnabled) {
            filtersToAddExport.splice(0, 0, <FiltersSelect
                key="productType"
                name="productType"
                id="productType"
                label="Product Type"
                options={[
                    ...searchProductTypesExtra
                ]}
            />);
            filtersToAddImport.splice(0, 0, <FiltersSelect
                key="productType"
                name="productType"
                id="productType"
                label="Product Type"
                options={isDCSFeatureEnabled ? [...optionsWithDCS] : [...searchProductTypesExtra]}
            />);
        }
        if (this.state.currentTabSelected === 1) {
            filtersToAdd = filtersToAddExport;
        } else {
            filtersToAdd = filtersToAddImport;
        }
        return (
            <React.Fragment>
                <PageHeader id="extraDocument-search">
                    Extra Document Configuration
                </PageHeader>
                <Page>
                    <ConfirmModal
                        title="Toggle Active"
                        visible={this.state.confirmDialogVisible}
                        onConfirm={this.confirmToggle}
                        closeModal={() => {
                            this.setState({ confirmDialogVisible: false });
                        }}
                    >
                        {this.state.confirmDialogMessage}
                    </ConfirmModal>
                    {this.state.extraDocumentCreationVisible &&
                        <ExtraDocumentCreation
                            selectedData={this.state.currentTabSelected === 1
                                ? this.exportTableReference.getSelectedItems()[0]
                                : this.importTableReference.getSelectedItems()[0]
                            }
                            documentType={this.state.currentTabSelected === 1 ? 'Export' : 'Import'}
                            closeModal={() => this.setState({ extraDocumentCreationVisible: false, rowIds: [] })}
                            submitData={this.processExtraDocumentCreation}
                            selectedRows={this.getSelectedRows}
                            selectedChildRows={this.state.rowIds}
                            currentUser={this.props.currentUserNickName}
                            showModal={this.state.extraDocumentCreationVisible}
                        />
                    }
                    {this.state.showExtraDocModal && (
                        <AddEditExtraDocConfigDialog
                            extraDocModalError={this.props.pendingError.toString()}
                            currentUser={this.props.currentUserNickName}
                            closeModal={this.processModalData}
                            exportDataModel={this.props.exportExtraDocumentConfig}
                            importDataModel={this.props.importExtraDocumentConfig}
                            initialConfigType={this.state.currentTabSelected === 1 ? 'Export' : 'Import'}
                            isBKSFeatureEnabled={isBKSFeatureEnabled}
                            isDCSFeatureEnabled={isDCSFeatureEnabled}
                            isFinopsAirEnabled={isFinopsAirEnabled}
                            isRailRoadEnabled={isRailRoadEnabled}
                        />
                    )}
                    <TabComponent
                        name="extraDocument-tab"
                        navLinks={[
                            {
                                id: 1,
                                title: 'Export',
                                emptyLabel: '',
                            },
                            {
                                id: 2,
                                title: 'Import',
                                emptyLabel: '',
                            },
                        ]}
                        callbackFc={(e: number) => {
                            const importExport = e === 1 ? 'export' : 'import';
                            this.props.history.push(
                                `/administration/extra-document/${importExport}`
                            );
                            this.setState({
                                currentTabSelected: e
                            });
                            if (this.state.currentTabSelected !== e) {
                                this.clear();
                                this.props.resetSort();
                            }
                        }}
                        activeTab={this.state.currentTabSelected - 1}
                    />

                    <Filters
                        tableNameKey="IssoRates"
                        fetchFunction={() => {
                            this.apply();
                        }}
                        resetErrors={() => {
                            this.props.applyFilters();
                        }}
                        disableSubmit={false}
                        filters={filtersToAdd}
                    />
                    <InPageDialog
                        showDialog={this.state.showStatusDialog}
                        type={this.state.statusDialogIsError ? 'error' : 'success'}
                        message={this.state.statusDialogMessage}
                        closeMethod={() =>
                            this.setState({
                                statusDialogMessage: '',
                                showStatusDialog: false,
                            })
                        }
                    />
                    {this.state.currentTabSelected === 1 && (
                        <DataTable
                            id={'ExtraDocumentExportTable'}
                            data={this.state.exportData}
                            columns={ExtraDocExportConfigTableData(isBKSFeatureEnabled)}
                            isEditable={false}
                            isExpandable={false}
                            isSelectable={true}
                            selectedOption={'single'}
                            isSortable={true}
                            isResizable={true}
                            hasFooter={false}
                            showColumnOptions={true}
                            tableName={'ExtraDocumentExportTable'}
                            manualPagination={true}
                            pageCount={Math.ceil(this.props.exportExtraDocumentConfigs.totalCount / this.props.exportExtraDocumentConfigs.pageSize)}
                            fetchData={(state: any, instance: any) => { this.fetchExtraDocumentConfigData(state, instance, 'export'); }}
                            showPagination={true}
                            defaultPageSize={10}
                            actions={actionsList}
                            ref={(ref: any) => {
                                this.exportTableReference = ref;
                                this.importTableReference = undefined;
                            }}
                        />
                    )}
                    {this.state.currentTabSelected === 2 && (
                        <DataTable
                            id={'ExtraDocumentImportTable'}
                            data={this.state.importData}
                            columns={ExtraDocImportConfigTableData(isBKSFeatureEnabled)}
                            isEditable={false}
                            isExpandable={false}
                            isSelectable={true}
                            selectedOption={'single'}
                            isSortable={true}
                            isResizable={true}
                            hasFooter={true}
                            showColumnOptions={true}
                            tableName={'ExtraDocumentImportTable'}
                            manualPagination={true}
                            pageCount={Math.ceil(this.props.importExtraDocumentConfigs.totalCount / this.props.importExtraDocumentConfigs.pageSize)}
                            fetchData={(state: any, instance: any) => { this.fetchExtraDocumentConfigData(state, instance, 'import'); }}
                            showPagination={true}
                            defaultPageSize={10}
                            actions={actionsList}
                            ref={(ref: any) => {
                                this.importTableReference = ref;
                                this.exportTableReference = undefined;
                            }}
                        />
                    )}
                </Page>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchDataLoading: state.extraDocument.isFetchDataLoading,
    isFetchDataError: state.extraDocument.isFetchDataError,
    pendingError: state.extraDocument.pendingError,
    currentUserNickName: state.nickname.userNickName,
    exportExtraDocumentConfigs: state.extraDocument.exportExtraDocumentConfigs,
    importExtraDocumentConfigs: state.extraDocument.importExtraDocumentConfigs,
    exportExtraDocumentConfig: state.extraDocument.exportExtraDocumentConfig,
    importExtraDocumentConfig: state.extraDocument.importExtraDocumentConfig,
    addExportResponse: state.extraDocument.addExportResponse,
    updateExportResponse: state.extraDocument.updateExportResponse,
    addImportResponse: state.extraDocument.addImportResponse,
    updateImportResponse: state.extraDocument.updateImportResponse,
    toggleActiveResponse: state.extraDocument.toggleActiveResponse,
    processExtraDocumentCreationImportRes: state.extraDocument.processExtraDocumentCreationImportRes,
    processExtraDocumentCreationExportRes: state.extraDocument.processExtraDocumentCreationExportRes,
    featureToggles: state.featureToggle.featureToggles
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<any, any, Action>
): IMapDispatchToProps => ({
    searchExportExtraDocument: (pageNumber?: number, pageSize?: number) => dispatch(searchExportExtraDocumentConfiguration(pageNumber, pageSize)),
    searchImportExtraDocument: (pageNumber?: number, pageSize?: number) => dispatch(searchImportExtraDocumentConfiguration(pageNumber, pageSize)),
    fetchExportExtraDocumentConfigurationById: (itemData: IExtraDocumentConfigurationListModel) => dispatch(fetchExportExtraDocumentConfigurationById(itemData)),
    addExportExtraDocumentConfiguration: (data: IExportExtraDocumentConfiguration) => dispatch(addExportExtraDocumentConfiguration(data)),
    updateExportExtraDocumentConfiguration: (data: IExportExtraDocumentConfiguration) => dispatch(updateExportExtraDocumentConfiguration(data)),
    resetExportExtraDocumentConfiguration: () => dispatch(resetExportExtraDocumentConfiguration()),
    fetchImportExtraDocumentConfigurationById: (itemData: IExtraDocumentConfigurationListModel) => dispatch(fetchImportExtraDocumentConfigurationById(itemData)),
    addImportExtraDocumentConfiguration: (data: IImportExtraDocumentConfiguration) => dispatch(addImportExtraDocumentConfiguration(data)),
    updateImportExtraDocumentConfiguration: (data: IImportExtraDocumentConfiguration) => dispatch(updateImportExtraDocumentConfiguration(data)),
    resetImportExtraDocumentConfiguration: () => dispatch(resetImportExtraDocumentConfiguration()),
    toggleActiveExtraDocumentConfiguration: (data: IToggleActiveExtraDocumentConfiguration) => dispatch(toggleActiveExtraDocumentConfiguration(data)),
    clearFilters: () => dispatch(clearFilters()),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction()),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    processExtraDocumentCreationImport: (data: any) => dispatch(processExtraDocumentCreationImport(data)),
    processExtraDocumentCreationExport: (data: any) => dispatch(processExtraDocumentCreationExport(data)),
});
const __ExtraDocuments = connect<
    IMapStateToProps,
    IMapDispatchToProps,
    {},
    IStore
>(
    mapStateToProps,
    mapDispatchToProps
)(_ExtraDocuments);
export const Index = withRouter(__ExtraDocuments);